import React, { useState } from "react";
import useMermaid, { parseMermaidToText } from "./useMermaid";

const MermaidBlock = ({ code }) => {
  const { svg, error, loading } = useMermaid(code);
  const [showRawCode, setShowRawCode] = useState(false);

  if (loading) {
    return (
      <div className="sb-mermaid-block sb-mermaid-loading">
        <div className="sb-mermaid-label">Loading diagram…</div>
        <div className="sb-mermaid-skeleton" />
      </div>
    );
  }

  if (error) {
    const { diagramType, relationships } = parseMermaidToText(code);

    return (
      <div className="sb-mermaid-block sb-mermaid-fallback">
        <div className="sb-mermaid-label">
          <span className="sb-mermaid-label-icon">📋</span>
          <span>{diagramType} (Text View)</span>
        </div>

        <div className="sb-mermaid-fallback-body">
          {relationships.length > 0 ? (
            <ul className="sb-mermaid-relationship-list">
              {relationships.map((rel, idx) => (
                <li key={idx} className="sb-mermaid-relationship-item">
                  {rel}
                </li>
              ))}
            </ul>
          ) : (
            <p className="sb-mermaid-fallback-empty">
              Diagram content could not be parsed into relationships.
            </p>
          )}

          <div className="sb-mermaid-info-banner">
            <span className="sb-mermaid-info-icon">ℹ</span>
            <span>
              Visual diagram rendering unavailable — content shown as text
            </span>
          </div>

          <button
            className="sb-mermaid-toggle-raw"
            onClick={() => setShowRawCode((prev) => !prev)}
            type="button"
          >
            {showRawCode ? "Hide source code ▲" : "Show source code ▼"}
          </button>

          {showRawCode && (
            <pre className="sb-mermaid-raw-code">
              <code>{code}</code>
            </pre>
          )}
        </div>
      </div>
    );
  }

  if (!svg) {
    return null;
  }

  return (
    <div className="sb-mermaid-block">
      <div className="sb-mermaid-label">📊 Architecture Diagram</div>
      <div
        className="sb-mermaid-svg-container"
        dangerouslySetInnerHTML={{ __html: svg }}
      />
    </div>
  );
};

export default MermaidBlock;
